import {
    getCommercialBodyTypeRequest,
    getCommercialCharacteristicRequest,
    getCommercialMarkRequest,
    getCommercialModelRequest,
    getCommercialModificationRequest,
    getCommercialTechDataRequest,
    getCommercialTypeRequest,
} from '../../../services/network/fields/commercial';

class CommercialDataFieldsService {
    async getCommercialType() {
        return await getCommercialTypeRequest();
    }

    async getCommercialMark(type) {
        return await getCommercialMarkRequest(type);
    }

    async getCommercialModel(params) {
        return await getCommercialModelRequest(params);
    }

    async getCommercialBodyType(params) {
        return await getCommercialBodyTypeRequest(params);
    }

    async getCommercialModification(params) {
        return await getCommercialModificationRequest(params);
    }

    async getCommercialCharacteristic(params) {
        return await getCommercialCharacteristicRequest(params);
    }

    async getCommercialTechData(params) {
        return await getCommercialTechDataRequest(params);
    }
}

export const CommercialDataLadderSearchService =
    new CommercialDataFieldsService();
